import { useEffect, useContext } from "react";

import LoadingContext from "../../context/Loading/Loading";
import { useModal } from "../../providers/ModalProvider/ModalProvider";

import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { PageLoadingContainer } from "../PageLoadingContainer";
import { Report } from "./Report";

import "./reportsWrapper.scss";
import { ExportModal } from "./ExportModal";

// Report Schema Definitions - can be moved to database later
const REPORT_SCHEMAS = {
  "club-seats": {
    title: "Club Seat Purchases Breakdown",
    filename: "club-seat-purchases",
    orientation: "landscape",
    category: "sales-attendance",
    displayName: "Club Seat Purchases",
    description: "Detailed breakdown of club seat purchases with fees and HST.",
    icon: "layers",
    columns: [
      { key: "eventName", label: "Event Name", width: "25%", type: "text" },
      { key: "eventId", label: "Event Id", width: "25%", type: "text" },
      { key: "eventDate", label: "Event Date", width: "25%", type: "date" },

      { key: "orderId", label: "Order ID", width: "25%", type: "number" },
      { key: "firstName", label: "First Name", width: "25%", type: "text" },
      { key: "lastName", label: "Last Name", width: "25%", type: "text" },
      { key: "email", label: "Email", width: "25%", type: "text" },
      {
        key: "phoneNumber",
        label: "Phone Number",
        width: "25%",
        type: "number",
      },
      {
        key: "salesChannel",
        label: "Sales Channel",
        width: "25%",
        type: "text",
      },
      { key: "offerName", label: "Offer Name", width: "25%", type: "text" },
      { key: "section", label: "Section", width: "25%", type: "text" },
      { key: "row", label: "Row", width: "25%", type: "text" },
      { key: "seats", label: "Seats", width: "25%", type: "text" },
      { key: "quantity", label: "Qty", width: "25%", type: "number" },
      { key: "basePrice", label: "Base Price", width: "25%", type: "number" },
      { key: "serviceFee", label: "Service Fee", width: "25%", type: "number" },
      {
        key: "facilityFee",
        label: "Facility Fee",
        width: "25%",
        type: "number",
      },
      { key: "salesTax", label: "Sales Tax", width: "25%", type: "number" },
      {
        key: "processingFee",
        label: "Processing Fee",
        width: "25%",
        type: "number",
      },
      { key: "grossSales", label: "Gross Sales", width: "25%", type: "number" },
      { key: "netSales", label: "Net Sales", width: "25%", type: "number" },
      {
        key: "paymentMethod",
        label: "Payment Method",
        width: "25%",
        type: "number",
      },
      { key: "last4", label: "Last4", width: "25%", type: "number" },
      { key: "city", label: "City", width: "25%", type: "text" },
      { key: "state", label: "State", width: "25%", type: "text" },
      { key: "zip", label: "Zip", width: "25%", type: "text" },
    ],
  },
  "scanned-by-section": {
    title: "Tickets Scanned by Arena Section",
    filename: "tickets-scanned-by-section",
    orientation: "portrait",
    category: "sales-attendance",
    displayName: "Scanned by Section",
    description: "Track ticket scanning rates by arena section.",
    icon: "receipt",
    columns: [
      { key: "eventName", label: "Event", width: "40%", type: "text" },
      { key: "eventDate", label: "Date", width: "40%", type: "date" },
      { key: "section", label: "Arena Section", width: "40%", type: "text" },
      { key: "quantity", label: "Section Qty", width: "40%", type: "number" },
      {
        key: "scanned",
        label: "Scanned",
        width: "30%",
        type: "number",
      },
      { key: "unscanned", label: "Unscanned", width: "40%", type: "number" },
      {
        key: "scanrate",
        label: "Scan Rate",
        width: "30%",
        type: "percentage",
      },
    ],
  },
  "sales-channel": {
    title: "Sales Channel Breakdown",
    filename: "sales-channel",
    orientation: "portrait",
    category: "sales-attendance",
    displayName: "Sales Channel",
    description:
      "Compare paid ticket sales against complementary tickets issued.",
    icon: "circleDollar",
    columns: [
      { key: "eventName", label: "Event", width: "30%", type: "text" },
      { key: "eventDate", label: "Date", width: "30%", type: "date" },
      {
        key: "salesChannel",
        label: "Sales Channel",
        width: "30%",
        type: "text",
      },
      { key: "quantity", label: "Qty", width: "30%", type: "number" },
      { key: "grossSales", label: "Gross Sales", width: "25%", type: "number" },
      { key: "netSales", label: "Net Sales", width: "25%", type: "number" },
    ],
  },
  "sales-per-game": {
    title: "Total Ticket Sales per Game",
    filename: "sales-per-game",
    orientation: "landscape",
    category: "track-ticket-sales",
    displayName: "Sales per Game",
    description: "Track gross and net sales for each game/event.",
    icon: "circleDollar",
    columns: [
      { key: "eventName", label: "Name of Event", width: "25%", type: "text" },
      { key: "eventDate", label: "Event Date", width: "25%", type: "date" },
      { key: "eventId", label: "Event ID", width: "25%", type: "text" },
      { key: "soldQuantity", label: "Sold Qty", width: "25%", type: "number" },
      { key: "compQuantity", label: "Comp Qty", width: "25%", type: "number" },
      {
        key: "packageSales",
        label: "Packages Qty",
        width: "25%",
        type: "number",
      },
      {
        key: "totalQuantity",
        label: "Total Qty",
        width: "25%",
        type: "number",
      },
      //   { key: "scanned", label: "Scanned", width: "25%", type: "number" },
      //   { key: "unscanned", label: "Unscanned", width: "25%", type: "number" },
      { key: "net", label: "Net Sales", width: "25%", type: "number" },
      {
        key: "netWithPackages",
        label: "Net Including Packages",
        width: "25%",
        type: "number",
      },
    ],
  },
  "aged-receivable": {
    title: "Aged Receivable Listing",
    filename: "aged-receivable",
    orientation: "landscape",
    category: "settlement",
    displayName: "Aged Receivables",
    description: "Track outstanding invoices and payment collection status.",
    icon: "calendar",
    columns: [
      { key: "type", label: "Type", width: "25%", type: "text" },
      { key: "name", label: "Name", width: "25%", type: "text" },
      { key: "firstName", label: "First Name", width: "25%", type: "text" },
      { key: "lastName", label: "Last Name", width: "25%", type: "text" },
      {
        key: "organization",
        label: "Organization",
        width: "25%",
        type: "text",
      },
      {
        key: "phoneNumber",
        label: "Phone Number",
        width: "25%",
        type: "number",
      },
      { key: "created", label: "Created", width: "25%", type: "text" },
      { key: "invoiceId", label: "Invoice #", width: "25%", type: "text" },
      { key: "invoiceLink", label: "Invoice Link", width: "25%", type: "text" },
      {
        key: "totalAmount",
        label: "Total Amount",
        width: "25%",
        type: "number",
      },
      { key: "amountDue", label: "Amount Due", width: "25%", type: "number" },
      //   {
      //     key: "daysOutstanding",
      //     label: "Days Outstanding",
      //     width: "25%",
      //     type: "text",
      //   },
      { key: "status", label: "Status", width: "25%", type: "text" },
    ],
  },
  "ar-aging-summary": {
    title: "A/R Aging Summary Report",
    filename: "ar-aging-summary",
    orientation: "landscape",
    category: "settlement",
    displayName: "A/R Aging Summary Report",
    description: "Summarize outstanding balances by customer and aging bucket.",
    icon: "calendar",
    dateMode: "asOf",
    columns: [
      { key: "customer", label: "Customer", width: "25%", type: "text" },
      { key: "current", label: "Current", width: "15%", type: "currency" },
      { key: "oneToThirty", label: "1 - 30", width: "15%", type: "currency" },
      {
        key: "thirtyOneToSixty",
        label: "31 - 60",
        width: "15%",
        type: "currency",
      },
      {
        key: "sixtyOneToNinety",
        label: "61 - 90",
        width: "15%",
        type: "currency",
      },
      {
        key: "ninetyPlus",
        label: "91 and over",
        width: "15%",
        type: "currency",
      },
      { key: "total", label: "Total", width: "15%", type: "currency" },
    ],
  },
  "daily-report": {
    title: "Daily Report - Event Summary",
    filename: "daily-report",
    orientation: "landscape",
    category: "track-ticket-sales",
    displayName: "Daily Report",
    description: "Daily breakdown of ticket sales, comps, and receivables.",
    icon: "clock",
    columns: [
      { key: "eventName", label: "Event", width: "25%", type: "text" },
      { key: "eventDate", label: "Date", width: "25%", type: "text" },
      { key: "eventId", label: "Event ID", width: "25%", type: "text" },
      { key: "eventStatus", label: "Status", width: "25%", type: "text" },

      {
        key: "yesterdaySold",
        label: "Y Tickets Sold",
        width: "25%",
        type: "number",
      },
      {
        key: "yesterdayGross",
        label: "Y Gross Sales",
        width: "25%",
        type: "number",
      },
      {
        key: "yesterdayNet",
        label: "Y Net Sales",
        width: "25%",
        type: "number",
      },

      {
        key: "todaySold",
        label: "TD Tickets Sold",
        width: "25%",
        type: "number",
      },
      {
        key: "todayGross",
        label: "TD Gross Sales",
        width: "25%",
        type: "number",
      },
      { key: "todayNet", label: "TD Net Sales", width: "25%", type: "number" },

      {
        key: "totalSold",
        label: "TT Tickets Sold",
        width: "25%",
        type: "number",
      },
      {
        key: "totalGross",
        label: "TT Gross Sales",
        width: "25%",
        type: "number",
      },
      { key: "totalNet", label: "TT Net Sales", width: "25%", type: "number" },

      { key: "comps", label: "Comps", width: "25%", type: "number" },
      { key: "packages", label: "Packages", width: "25%", type: "number" },
      {
        key: "totalAllocated",
        label: "Total Allocated",
        width: "25%",
        type: "number",
      },
    ],
  },
  "order-listings": {
    title: "Order Listings",
    filename: "order-listings",
    orientation: "landscape",
    category: "settlement",
    displayName: "Order Listings",
    description:
      "View all order records from Website, Box Office, and Ticket Assignment orders within the selected date range.",
    icon: "receipt",
    columns: [
      { key: "eventName", label: "Name of Event", width: "25%", type: "text" },
      { key: "eventDate", label: "Event Date", width: "25%", type: "text" },
      { key: "eventId", label: "Event ID", width: "25%", type: "text" },
      { key: "orderId", label: "Order ID", width: "25%", type: "number" },
      { key: "orderDate", label: "Order Date", width: "25%", type: "date" },
      { key: "firstName", label: "First Name", width: "25%", type: "text" },
      { key: "lastName", label: "Last Name", width: "25%", type: "text" },
      { key: "email", label: "Email", width: "25%", type: "text" },
      {
        key: "phoneNumber",
        label: "Phone Number",
        width: "25%",
        type: "number",
      },
      {
        key: "salesChannel",
        label: "Sales Channel",
        width: "25%",
        type: "text",
      },
      { key: "offerName", label: "Offer Name", width: "25%", type: "text" },
      { key: "section", label: "Section", width: "25%", type: "text" },
      { key: "row", label: "Row", width: "25%", type: "text" },
      { key: "seats", label: "Seat(s)", width: "25%", type: "text" },
      { key: "quantity", label: "Qty", width: "25%", type: "number" },
      { key: "basePrice", label: "Base Price", width: "25%", type: "number" },
      { key: "serviceFee", label: "Service Fee", width: "25%", type: "number" },
      {
        key: "facilityFee",
        label: "Facility Fee",
        width: "25%",
        type: "number",
      },
      { key: "salesTax", label: "Sales Tax", width: "25%", type: "number" },
      {
        key: "chargeBackProtection",
        label: "chargeBackProtection",
        width: "25%",
        type: "number",
      },
      {
        key: "processingFee",
        label: "Processing Fee",
        width: "25%",
        type: "number",
      },
      { key: "grossSales", label: "Gross Sales", width: "25%", type: "number" },
      { key: "netSales", label: "Net Sales", width: "25%", type: "number" },
      {
        key: "paymentMethod",
        label: "Payment Method",
        width: "25%",
        type: "text",
      },
      { key: "last4", label: "Last 4", width: "25%", type: "number" },
      { key: "city", label: "City", width: "25%", type: "text" },
      { key: "state", label: "State", width: "25%", type: "text" },
      { key: "zip", label: "Zip", width: "25%", type: "text" },
    ],
  },
  "packages-report": {
    title: "Packages Report",
    filename: "packages-report",
    orientation: "landscape",
    category: "sales-attendance",
    displayName: "Packages Report",
    description:
      "Track season ticket holder details, packages, and renewal status.",
    icon: "layers",
    columns: [
      { key: "packageName", label: "Package Name", width: "25%", type: "text" },
      { key: "packageDate", label: "Package Date", width: "25%", type: "date" },
      { key: "packageId", label: "Package ID", width: "25%", type: "text" },
      { key: "orderId", label: "Order ID", width: "25%", type: "text" },
      { key: "orderDate", label: "Order Date", width: "25%", type: "date" },
      {
        key: "organization",
        label: "Organization",
        width: "25%",
        type: "text",
      },
      { key: "firstName", label: "First Name", width: "25%", type: "text" },
      { key: "lastName", label: "Last Name", width: "25%", type: "text" },
      { key: "email", label: "Email", width: "25%", type: "text" },
      {
        key: "phoneNumber",
        label: "Phone Number",
        width: "25%",
        type: "number",
      },
      { key: "salesRep", label: "Sales Rep", width: "25%", type: "text" },
      { key: "buyerType", label: "Buyer Type", width: "25%", type: "text" },
      {
        key: "salesChannel",
        label: "Sales Channel",
        width: "25%",
        type: "text",
      },
      { key: "section", label: "Section", width: "25%", type: "text" },
      { key: "row", label: "Row", width: "25%", type: "text" },
      { key: "seats", label: "Seats", width: "25%", type: "text" },
      { key: "quantity", label: "Qty", width: "25%", type: "number" },
      { key: "basePrice", label: "Base Price", width: "25%", type: "number" },
      { key: "serviceFee", label: "Service Fee", width: "25%", type: "number" },
      { key: "salesTax", label: "Sales Tax", width: "25%", type: "number" },
      {
        key: "processingFee",
        label: "Processing Fee",
        width: "25%",
        type: "number",
      },
      { key: "grossSales", label: "Gross Sales", width: "25%", type: "number" },
      { key: "netSales", label: "Net Sales", width: "25%", type: "number" },
      {
        key: "paymentMethod",
        label: "Payment Method",
        width: "25%",
        type: "text",
      },
      { key: "last4", label: "Last4", width: "25%", type: "number" },
      { key: "city", label: "City", width: "25%", type: "text" },
      { key: "state", label: "State", width: "25%", type: "text" },
      { key: "state", label: "Zip", width: "25%", type: "text" },
    ],
  },
};

// Category Configuration
const CATEGORIES = {
  "track-ticket-sales": {
    title: "Track Ticket Sales",
    subtitle:
      "Monitor ticket sales across all your events to stay ahead on performance.",
  },
  "sales-attendance": {
    title: "Sales & Attendance Reports",
    subtitle: "Understand how people are buying and attending your events.",
  },
  settlement: {
    title: "Settlement Reports",
    subtitle: "Generate reports tailored to your settlement needs.",
  },
};

export default function ReportsWrapper() {
  const { isLoading, hideLoading } = useContext(LoadingContext);
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    hideLoading();
  }, []);

  // Helper function to get reports by category
  const getReportsByCategory = (category) => {
    return Object.entries(REPORT_SCHEMAS)
      .filter(([key, schema]) => schema.category === category)
      .map(([key, schema]) => ({ key, ...schema }));
  };

  // Helper function to render reports for a category
  const renderCategoryReports = (categoryKey) => {
    const reports = getReportsByCategory(categoryKey);
    const category = CATEGORIES[categoryKey];

    if (!category || reports.length === 0) return null;

    return (
      <Card body key={categoryKey}>
        <div className="card-body-heading card-body-heading--sm">
          <Card.Title as="h2">{category.title}</Card.Title>
          <Card.Subtitle as="h3" className="mt-2">
            {category.subtitle}
          </Card.Subtitle>
        </div>
        <Row className="g-3">
          {reports.map((report) => (
            <Col
              xs={12}
              sm={6}
              lg={4}
              key={report.key}
              className="flex d-flex-column"
            >
              <Report
                name={report.displayName}
                description={report.description}
                icon={report.icon}
                handleClick={() => handleReportClick(report.key)}
              />
            </Col>
          ))}
        </Row>
      </Card>
    );
  };

  const handleReportClick = (reportType) => {
    const reportSchema = REPORT_SCHEMAS[reportType];

    if (!reportSchema) {
      console.error(`Report schema not found for type: ${reportType}`);
      return;
    }

    openModal(
      ExportModal,
      {
        reportSchema: reportSchema,
        reportType: reportType,
        onCancel: closeModal,
      },
      { className: "modal-lg" },
    );
  };

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer style="without-sidebar" />
      ) : (
        <section id="custom-reports">
          <header className="section-header">
            <div className="section-heading">
              <h1>Reports</h1>
            </div>
          </header>
          <section>
            <Stack gap={4}>
              {Object.keys(CATEGORIES).map((categoryKey) =>
                renderCategoryReports(categoryKey),
              )}
            </Stack>
          </section>
        </section>
      )}
    </>
  );
}
